import type { FetchStatus, QueryStatus } from '@tanstack/react-query';

// Query statuses helpers
export const isQueryLoading = (status: QueryStatus): boolean => status === 'loading';
export const isQueryError = (status: QueryStatus): boolean => status === 'error';
export const isQuerySuccess = (status: QueryStatus): boolean => status === 'success';

// Fetch statuses helpers
export const isFetchLoading = (status: FetchStatus): boolean => status === 'fetching';
export const isFetchIdling = (status: FetchStatus): boolean => status === 'idle';
export const isFetchPaused = (status: FetchStatus): boolean => status === 'paused';
